import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"
import { compose } from "recompact"
import queryString from "query-string"

export default (to = `queryParams`, toApi = `queryApi`) =>
  compose(
    withRouter,
    BaseComponent =>
      class Hoc extends Component {
        constructor(...args) {
          super(...args)
          this.calcQueryParams(this.props)
          this.api = {
            pushParams: params => {
              const { queryParams, props } = this
              const { location, history } = props
              const nextQuery = {
                ...queryParams,
                ...params,
              }
              history.push(
                `${location.pathname}?${queryString.stringify(nextQuery)}`,
              )
            },
            replaceParams: (params = {}) => {
              const { location, history } = this.props
              history.replace(
                `${location.pathname}?${queryString.stringify(params)}`,
              )
            },
            push: (pathname, params) => {
              const { props, queryParams } = this
              const nextQuery = {
                ...queryParams,
                ...params,
              }
              props.history.push(
                `${pathname}?${queryString.stringify(nextQuery)}`,
              )
            },
            Link: props => {
              const nextQuery = {
                ...this.queryParams,
                ...props.params,
              }
              const { pathname } = this.props
              return (
                <Link
                  to={{
                    pathname: props.pathname || pathname,
                    search: `?${queryString.stringify(nextQuery)}`,
                  }}
                  {...props}
                />
              )
            },
          }
        }

        // eslint-disable-next-line camelcase
        UNSAFE_componentWillReceiveProps(nextProps) {
          const { location } = this.props
          if (nextProps.location !== location) {
            this.calcQueryParams(nextProps)
          }
        }

        calcQueryParams({ location: { search } }) {
          this.queryParams = queryString.parse(search) || {}
        }

        render() {
          const advancedProps = {
            [to]: this.queryParams,
            [toApi]: this.api,
          }
          return <BaseComponent {...this.props} {...advancedProps} />
        }
      },
  )
